<div class="dashboard__content mt-4 pb-5" [class.d-none]="!isLoaded">
  <div class="row mb-4 wh-breadcrumb g-0 text-uppercase">

    <div class="col-auto">
      <span class="small text-muted">Winning Hands Admin</span>
    </div>
    <div class="col-auto">
      <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
      <a [routerLink]="[ '/', 'admin', 'events' ]" class="small text-muted text-decoration-none"> Events</a>
    </div>
    <div class="col-auto">
      <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
      <a [routerLink]="[ '/', 'admin', 'events', eventDetail.eventID]" class="small text-muted text-decoration-none">
        {{eventDetail.eventName}}</a>
    </div>
    <div class="col-auto">
      <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
      <a [routerLink]="[ '/', 'admin', 'events', eventDetail.eventID, 'therapists', 'clocked-in']"
        class="small text-primary text-decoration-none"> Therapists clocked in</a>
    </div>
  </div>


  <div class="row mb-4">
    <div class="col-lg col-12">
      <h1 class="mb-0">CLOCKED IN THERAPISTS</h1>
    </div>
    <div class="col-lg-auto mt-3 mt-lg-0 col-12 d-flex align-items-center justify-content-lg-end">

    </div>
  </div>




  <div class="row">
    <div class="col-12" style="width: 100%; overflow-x: auto;">
      <table matSort class="admin-table" mat-table [dataSource]="dataSource">


        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element">
            <img class="img-fluid rounded-pill" style="width: 40px; height: 40px; margin-right: 15px; min-width: 40px;"
              src="{{getThumbURL(element.therapist.profileLargeURL)}}">
          </td>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>FIRST NAME</th>
          <td mat-cell *matCellDef="let element">{{element.therapist.firstName}} </td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>LAST NAME</th>
          <td mat-cell *matCellDef="let element"> {{element.therapist.lastName}} </td>
        </ng-container>

        <ng-container matColumnDef="waiting">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIENTS WAITING</th>
          <td mat-cell *matCellDef="let element"> {{element.numberWaitingForThem}} </td>
        </ng-container>

        <ng-container matColumnDef="clockedInTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>CLOCKED IN TIME</th>
          <td mat-cell *matCellDef="let element"> {{element.clockedInTime | date:'d MMM YYYY @ HH:mm'}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
          <td mat-cell *matCellDef="let element">
            @if (element.currentMassageDetails){
            <span
              matTooltip="{{element.therapist.firstName}} is currently in a massage with {{element.currentMassageDetails.fullName}} since {{element.currentMassageDetails.treatmentStart | date:'HH:mm'}}">MASSAGE
              IN PROGRESS</span>
            }@else{
            {{element.status}}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="breakTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>BREAK TIME</th>
          <td mat-cell *matCellDef="let element"> {{element.totalBreakTimeInLast24Hours}} mins </td>
        </ng-container>

        <ng-container matColumnDef="totalTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>TOTAL TIME</th>
          <td mat-cell *matCellDef="let element"> {{element.totalMassageTimeSinceClockIn}} mins </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ACTIONS</th>
          <td mat-cell *matCellDef="let element"> <button matTooltip="Clock out {{element.firstName}}"
              (click)="clockOut(element.therapist.therapistID);" mat-icon-button aria-label="Edit therapist details">
              <mat-icon>alarm_off</mat-icon>
            </button></td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
    </div>
  </div>
</div>
